import { paginatedQuery } from 'lib-shared-api-utils';
import { api } from 'utils/apis/api';
import { transformCustomCardIntegrationArg } from './utils/transformArg';
import { transformCustomCardIntegrationByIdResponse, transformCustomCardIntegrationsResponse, } from './utils/transformResponse';
export const integrationsApi = api
    .enhanceEndpoints({
    addTagTypes: ['CustomCard'],
})
    .injectEndpoints({
    endpoints: (builder) => ({
        readEmailIntegrations: builder.query({
            query: (arg) => paginatedQuery(arg, () => ({
                version: 2,
                path: 'integrations/email',
            })),
        }),
        createEmailIntegration: builder.mutation({
            query: (body) => ({
                version: 1,
                method: 'POST',
                path: 'integrations/email',
                body,
            }),
        }),
        updateEmailIntegration: builder.mutation({
            query: ({ emailAddress, patch: body }) => ({
                version: 1,
                method: 'PATCH',
                path: `integrations/email/${emailAddress}`,
                body,
            }),
        }),
        deleteEmailIntegration: builder.mutation({
            query: ({ emailAddress }) => ({
                version: 1,
                method: 'DELETE',
                path: `integrations/email/${emailAddress}`,
            }),
        }),
        readEmailIntegrationDomains: builder.query({
            query: () => ({
                version: 1,
                path: 'integrations/email/domains',
            }),
        }),
        readCustomCardIntegrationById: builder.query({
            query: ({ hookId }) => ({
                version: 3,
                path: `integrations/customcards/${hookId}`,
            }),
            transformResponse: transformCustomCardIntegrationByIdResponse,
            providesTags: ['CustomCard'],
        }),
        readCustomCardIntegrations: builder.query({
            query: () => ({
                version: 1,
                path: 'integrations/customcard',
            }),
            transformResponse: transformCustomCardIntegrationsResponse,
            providesTags: ['CustomCard'],
        }),
        createCustomCardIntegration: builder.mutation({
            query: (body) => ({
                version: 1,
                path: 'integrations/customcard',
                method: 'PUT',
                body: transformCustomCardIntegrationArg(body),
            }),
            invalidatesTags: ['CustomCard'],
        }),
        updateCustomCardIntegration: builder.mutation({
            query: (body) => ({
                version: 1,
                path: 'integrations/customcard',
                method: 'PUT',
                body: transformCustomCardIntegrationArg(body),
            }),
            invalidatesTags: ['CustomCard'],
        }),
        deleteCustomCardIntegration: builder.mutation({
            query: ({ hookId }) => ({
                version: 1,
                path: `integrations/customcard/${hookId}`,
                method: 'DELETE',
            }),
            invalidatesTags: ['CustomCard'],
        }),
        readCustomCardTestIntegration: builder.query({
            query: ({ hookId, query = '' }) => {
                return {
                    version: 1,
                    path: `integrations/customcard/${hookId}${query}`,
                };
            },
            providesTags: ['CustomCard'],
        }),
        updateCustomCardTestIntegration: builder.mutation({
            query: ({ hookId, query = '', template }) => {
                return {
                    version: 3,
                    path: `integrations/customcards/${hookId}/test${query}`,
                    method: 'PUT',
                    body: { template },
                };
            },
        }),
    }),
});
